//Force encoding -> _Íì_ 
exports.getWindows = function() {
	return[
		{	"id" : 1
			,"name" : "FAKRO U2/U3/U31"
			,"link" : "https://www.fakro.com.mx/productos/todos-los-productos/ventanas-y-puertas-de-aluminio-y-madera/ventanas-y-puertas/caracteristicas/"
			,"thickness" : 24
			,"cgcs_value" : 0.525
			,"shade_coefficient" : 0.6
			,"u_value" : 1
		},
		{	"id" : 2
			,"name" : "FAKRO U6/U61"
			,"link" : "https://www.fakro.com.mx/productos/todos-los-productos/ventanas-y-puertas-de-aluminio-y-madera/ventanas-y-puertas/caracteristicas/"
			,"thickness" : 52.76
			,"cgcs_value" : 0.47
			,"shade_coefficient" : 0.54
			,"u_value" : 0.5
		},
		{	"id" : 3
			,"name" : "Vidrio Doble"
			,"link" : "https://www.fakro.com.mx/productos/todos-los-productos/ventanas-y-puertas-de-aluminio-y-madera/ventanas-y-puertas/caracteristicas/"
			,"thickness" : 20
			,"cgcs_value" : 0.77
			,"shade_coefficient" : 0.89
			,"u_value" : 2.9
		},
		{	"id" : 4
			,"name" : "Vidrio Entintado"
			,"link" : "https://www.fakro.com.mx/productos/todos-los-productos/ventanas-y-puertas-de-aluminio-y-madera/ventanas-y-puertas/caracteristicas/"
			,"thickness" : 3
			,"cgcs_value" : 0.48
			,"shade_coefficient" : 0.55
			,"u_value" : 6.64
		},
		{	"id" : 5
			,"name" : "Vidrio Sencillo"
			,"link" : "https://www.fakro.com.mx/productos/todos-los-productos/ventanas-y-puertas-de-aluminio-y-madera/ventanas-y-puertas/caracteristicas/"
			,"thickness" : 3
			,"cgcs_value" : 0.87
			,"shade_coefficient" : 1
			,"u_value" : 5.8
		}
	];
}
